import { render, staticRenderFns } from "./BillingPlans.vue?vue&type=template&id=edbeef8e&scoped=true"
import script from "./BillingPlans.vue?vue&type=script&lang=js"
export * from "./BillingPlans.vue?vue&type=script&lang=js"
import style0 from "./BillingPlans.vue?vue&type=style&index=0&id=edbeef8e&prod&scoped=true&lang=scss"
import style1 from "./BillingPlans.vue?vue&type=style&index=1&id=edbeef8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbeef8e",
  null
  
)

export default component.exports